import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../_helpers/Api'
import { plural, trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import loader from '../../../../assets/img/loader.svg'
import { Checkbox, FormControlLabel, Switch } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import ExceptionField from './ExceptionField'

function AddOrEdit(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: {},
        loading: false,
        loadingData: false,
    })
    const [exceptions, setExceptions] = useState([])
    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                loading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            setPopup(prev => ({
                ...prev,
                loadingData: true,
            }))
            Api.get(`contractors/subscriptions/types/find?id=${popup.editId}`)
                .then(res => {
                    setPopup(prev => ({
                        ...prev,
                        data: res.data,
                    }))
                    // Load exceptions from data if available
                    if (res.data?.exceptions && Array.isArray(res.data.exceptions)) {
                        setExceptions(res.data.exceptions)
                    }
                })
                .finally(() => {
                    setPopup(prev => ({
                        ...prev,
                        loadingData: false,
                    }))
                })
        }

    }, [popup.edit])


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                data: {},
                edit: false,
                editId: null,
            }))
            setExceptions([])
        }, 50)

        setValidations(null)
    }

    const handleSave = e => {
        e.preventDefault()


        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'contractors/subscriptions/types/' + (popup.edit ? 'edit' : 'add')

        let data = new FormData(e.target)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide(e)

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        const { name, value } = e.target

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: value,
            }
        }))
    }

    function handleSwitchChange(e) {
        const { name, checked } = e.target

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: checked ? 1 : 0,
            }
        }))
    }

    const updateExceptionField = (index, field, value) => {
        const next = exceptions.slice()
        next[index] = { ...(next[index] || {}), [field]: value }
        setExceptions(next)
    }

    const handleAddException = () => {
        const next = [...exceptions, {}]
        setExceptions(next)
    }

    const handleRemoveException = (index) => {
        const next = exceptions.slice()
        next.splice(index, 1)
        setExceptions(next)
    }

    const handleCheckboxChange = e => {
        const { name } = e.target

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary popup-subscription-type medium`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {popup.edit ? trans('headings.editType') : trans('headings.addType')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>
                {popup.loadingData ?
                    <Skeleton height={45} count={5} />
                    :
                    <>
                        <div className="row">
                            <div className="col">
                                <label>
                                    {trans('labels.name')}
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    value={popup.data?.name || ''}
                                    onChange={handleInputChange}
                                    className={validations && validations.name ? 'validate' : ''}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div
                                className="col"
                                style={{
                                    maxWidth: "150px"
                                }}
                            >
                                <label>
                                    {trans('labels.price')}
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    name="price"
                                    value={popup.data?.price || ''}
                                    onChange={handleInputChange}
                                    className={validations && validations.price ? 'validate' : ''}
                                />
                            </div>
                            <div
                                className='col'
                            >
                                <div className='period-select'>
                                    <label>
                                        {trans('labels.period')}
                                    </label>
                                    <div className='select-holder'>
                                        <input
                                            type="number"
                                            min="0"
                                            step="1"
                                            name="period"
                                            value={popup.data?.period || ''}
                                            onChange={handleInputChange}
                                            className={validations && validations.period ? 'validate' : ''}
                                            style={{
                                                maxWidth: "100px"
                                            }}
                                        />
                                        <select
                                            name="period_type"
                                            className={validations && validations.period_type ? 'validate' : ''}
                                            value={popup.data && popup.data.period_type ? popup.data.period_type : ''}
                                            onChange={handleInputChange}
                                        >
                                            <option value={1}>
                                                {plural('plural_periods.day', popup.data?.period || 1)}
                                            </option>
                                            <option value={2}>
                                                {plural('plural_periods.week', popup.data?.period || 1)}
                                            </option>
                                            <option value={3}>
                                                {plural('plural_periods.month', popup.data?.period || 1)}
                                            </option>
                                            <option value={4}>
                                                {plural('plural_periods.year', popup.data?.period || 1)}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="auto_invoicing_on"
                                            checked={popup.data?.auto_invoicing_on ? true : false}
                                            onChange={handleSwitchChange}
                                            value={popup.data?.auto_invoicing_on}
                                        />
                                    }
                                    label={trans('labels.autoInvoicing')}
                                />
                            </div>
                        </div>
                        <hr />

                        <div className='row'>
                            <div className='col'>
                                <b>
                                    {trans('labels.invoicePaymentPeriod')}
                                </b>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="has_payment_terms"
                                            value="1"
                                            checked={popup.data.has_payment_terms ? true : false}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    }
                                    label={trans('labels.setInvoicePaymentPeriod')}
                                />
                                {popup.data.has_payment_terms ?
                                    <select
                                        style={{
                                            width: "fit-content",
                                            flexShrink: 0,
                                        }}
                                        name="payment_terms_value"
                                        value={popup.data && popup.data.payment_terms_value ? popup.data.payment_terms_value : 7}
                                        onChange={handleInputChange}
                                    >
                                        <option value="7">
                                            {trans('random.upToOneWeek')}
                                        </option>
                                        <option value="14">
                                            {trans('random.upToTwoWeeks')}
                                        </option>
                                        <option value="21">
                                            {trans('random.upToThreeWeeks')}
                                        </option>
                                        <option value="28">
                                            {trans('random.upToFourWeeks')}
                                        </option>
                                    </select>
                                    :
                                    <>
                                    </>
                                }
                            </div>
                        </div>
                        {popup.data.has_payment_terms ?
                            <>
                                {exceptions.map((item, index) => (
                                    <ExceptionField
                                        key={index}
                                        exception={item}
                                        index={index}
                                        totalCount={exceptions.length}
                                        onUpdateField={updateExceptionField}
                                        onRemove={handleRemoveException}
                                    />
                                ))}
                                <div className='row'>
                                    <button className="button-add button-small" type='button' onClick={handleAddException}>
                                        {trans('buttons.addException')}
                                    </button>
                                </div>
                            </>
                            :
                            <>
                            </>
                        }

                    </>
                }

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(AddOrEdit)